document.addEventListener("DOMContentLoaded", function () {
  const phrases = [
    "With Illumipeak™",
    "Day or Night",
    "Wherever You Set Up",
    "With 360° Light Power"
  ];

  const el = document.getElementById("typewriter");
  if (!el || !phrases.length) return;

  let phraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  const typingSpeed = 90;
  const erasingSpeed = 45;
  const delayBetween = 1800;

  function type() {
    const currentPhrase = phrases[phraseIndex];

    if (!isDeleting && charIndex < currentPhrase.length) {
      // typing forward
      el.textContent += currentPhrase.charAt(charIndex);
      charIndex++;
      setTimeout(type, typingSpeed);

    } else if (isDeleting && charIndex > 0) {
      // deleting
      el.textContent = currentPhrase.substring(0, charIndex - 1);
      charIndex--;
      setTimeout(type, erasingSpeed);

    } else {
      // pause & flip state
      if (!isDeleting) {
        isDeleting = true;
        setTimeout(type, delayBetween);
      } else {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        setTimeout(type, typingSpeed);
      }
    }
  }

  // small delay so it doesn’t feel “jumpy” on reload
  setTimeout(type, 400);
});

// Anchor Scroll Controls (No Lag)

document.addEventListener('DOMContentLoaded', function () {
  const link = document.querySelector('a[href="#anchor"]');
  if (!link) return;

  link.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.getElementById('anchor');
    if (!target) return;

    const offset = -120;
    const startY = window.scrollY;
    const targetY = target.getBoundingClientRect().top + window.scrollY + offset;

    const duration = 1500;
    let startTime = null;

    function animateScroll(now) {
      if (!startTime) startTime = now;

      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 0.5 - Math.cos(progress * Math.PI) / 2;

      window.scrollTo(0, startY + (targetY - startY) * ease);

      if (progress < 1) requestAnimationFrame(animateScroll);
    }

    requestAnimationFrame(animateScroll);
  });
});

// FAQ Page Accordion

document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('#illumipeak-faq .faq-item');

    faqItems.forEach((item) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close all items (optional – makes it a true accordion)
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-open');
            const otherButton = otherItem.querySelector('.faq-question');
            const otherAnswer = otherItem.querySelector('.faq-answer');
            const otherIcon = otherItem.querySelector('.faq-icon');

            otherButton.setAttribute('aria-expanded', 'false');
            otherAnswer.hidden = true;
            otherIcon.textContent = '+';
          }
        });

        // Toggle current item
        if (isOpen) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
          icon.textContent = '+';
        } else {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
          icon.textContent = '−'; // minus sign
        }
      });
    });
  });


  // Image Swap

  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.illumipeak-toggle');
    if (!toggle) return;

    var imgOff = document.querySelector('.illumipeak-hero-img--off');
    var imgOn  = document.querySelector('.illumipeak-hero-img--on');

    if (!imgOff || !imgOn) return;

    var isOn = false;

    toggle.addEventListener('click', function () {
      isOn = !isOn;

      if (isOn) {
        imgOff.classList.remove('is-active');
        imgOn.classList.add('is-active');
        toggle.classList.add('is-on');
        toggle.setAttribute('aria-pressed', 'true');
      } else {
        imgOn.classList.remove('is-active');
        imgOff.classList.add('is-active');
        toggle.classList.remove('is-on');
        toggle.setAttribute('aria-pressed', 'false');
      }
    });
  });



// Dimmer Video Scroll Based Animation

 document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('illumipeak-scroll-video');
    const video = document.getElementById('illumipeakScrollVideo');

    if (!section || !video) return;

    let videoDuration = 0;
    let isMetaLoaded = false;
    let ticking = false;

    video.addEventListener('loadedmetadata', () => {
      videoDuration = video.duration || 0;
      isMetaLoaded = true;
      video.pause();
    });

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateVideoOnScroll() {
      ticking = false;
      if (!isMetaLoaded || !videoDuration) return;

      const rect = section.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      // If section is completely above or below viewport, keep last frame
      if (rect.bottom <= 0 || rect.top >= windowHeight) {
        return;
      }

      // Base progress:
      // 0  → when section top touches bottom of viewport
      // 1  → when section has fully passed above the top of viewport
      const totalScroll = rect.height + windowHeight;
      const scrollProgress = (windowHeight - rect.top) / totalScroll;
      const baseProgress = clamp(scrollProgress, 0, 1);

      // Delay: don't start scrubbing until we've scrolled
      // a bit into the section.
      // Example: 0.35 = 35% of the scroll before video starts moving.
      const startDelay = 0.05;

      if (baseProgress <= startDelay) {
        // Hold at first frame until delay has passed
        video.currentTime = 0;
        return;
      }

      // Remap [startDelay, 1] → [0, 1]
      const delayedProgress = (baseProgress - startDelay) / (1 - startDelay);
      const progress = clamp(delayedProgress, 0, 1);

      const newTime = progress * videoDuration;
      if (!isNaN(newTime)) {
        video.currentTime = newTime;
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateVideoOnScroll);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // Initial sync
    onScroll();
  });


// Dimmer Video Loop 

// document.addEventListener('DOMContentLoaded', function () {
//   const section = document.getElementById('illumipeak-scroll-video');
//   const video = document.getElementById('illumipeakScrollVideo');

//   if (!section || !video) return;

//   /* =====================
//      SETTINGS
//      ===================== */
//   const playDelayMs = 250; // delay before playing (ms)
//   const threshold = 0.35;  // % of section visible to trigger
//   /* ===================== */

//   let hasStarted = false;
//   let delayTimer = null;

//   // Enable looping
//   video.loop = true;

//   // Encourage buffering (safe on iOS)
//   video.preload = 'metadata';

//   function startVideo() {
//     if (hasStarted) return;
//     hasStarted = true;

//     const playPromise = video.play();
//     if (playPromise && typeof playPromise.catch === 'function') {
//       playPromise.catch(() => {
//         // Autoplay fallback (muted should allow this)
//         hasStarted = false;
//       });
//     }
//   }

//   const observer = new IntersectionObserver(
//     (entries) => {
//       const entry = entries[0];
//       if (!entry) return;

//       if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
//         if (!delayTimer) {
//           delayTimer = setTimeout(() => {
//             startVideo();
//           }, playDelayMs);
//         }
//       } else {
//         // If user scrolls away before delay finishes, cancel
//         if (delayTimer) {
//           clearTimeout(delayTimer);
//           delayTimer = null;
//         }
//       }
//     },
//     { threshold: [threshold] }
//   );

//   observer.observe(section);

// });